export default __webpack_public_path__ + "static/media/arrow_down.6132c731.svg";